import { api } from './api';

export interface ChannelDto {
  id: number;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface ProductChannelListingDto {
  id: number;
  productId?: number;  // Varyantsız ürünler için
  productVariantId?: number;  // Varyantlı ürünler için
  channelId: number;
  channelName?: string;
  listingStatus: number; // 1: Draft, 2: Active, 3: Inactive, 4: Suspended, 5: Deleted
  channelSku?: string;
  createdAt: string;
  updatedAt?: string;
  // Stock bilgisi
  quantity?: number;
  reservedQuantity?: number;
  availableQuantity?: number;
  lastUpdated?: string;
}

export interface ChannelStockRuleDto {
  id: number;
  channelId: number;
  channelName?: string;
  ruleType: number; // 1: MinStock, 2: MaxStock, 3: SafetyStock
  ruleTypeName?: string;
  value: number;
  priority: number;
  createdAt: string;
  updatedAt?: string;
}

export const fetchChannels = async (): Promise<ChannelDto[]> => {
  const { data } = await api.get<ChannelDto[]>('/channels');
  return data;
};

export const fetchChannel = async (id: number): Promise<ChannelDto> => {
  const { data } = await api.get<ChannelDto>(`/channels/${id}`);
  return data;
};

export const createChannel = async (channel: { name: string; isActive?: boolean }): Promise<ChannelDto> => {
  const { data } = await api.post<ChannelDto>('/channels', channel);
  return data;
};

export const updateChannel = async (id: number, channel: { name: string; isActive?: boolean }): Promise<ChannelDto> => {
  const { data } = await api.put<ChannelDto>(`/channels/${id}`, channel);
  return data;
};

export const deleteChannel = async (id: number): Promise<void> => {
  await api.delete(`/channels/${id}`);
};

// Product Channel Listing işlemleri
export const fetchProductChannelListings = async (productId?: number, productVariantId?: number, channelId?: number): Promise<ProductChannelListingDto[]> => {
  const params = new URLSearchParams();
  if (productId) params.append('productId', productId.toString());
  if (productVariantId) params.append('productVariantId', productVariantId.toString());
  if (channelId) params.append('channelId', channelId.toString());
  
  const { data } = await api.get<ProductChannelListingDto[]>(`/productchannellistings?${params.toString()}`);
  return data;
};

export const createProductChannelListing = async (listing: {
  productId?: number;  // Varyantsız ürünler için
  productVariantId?: number;  // Varyantlı ürünler için
  channelId: number;
  listingStatus?: number;
  channelSku?: string;
}): Promise<ProductChannelListingDto> => {
  const { data } = await api.post<ProductChannelListingDto>('/productchannellistings', listing);
  return data;
};

export const updateProductChannelListing = async (id: number, listing: {
  listingStatus?: number;
  channelSku?: string;
}): Promise<ProductChannelListingDto> => {
  const { data } = await api.put<ProductChannelListingDto>(`/productchannellistings/${id}`, listing);
  return data;
};

export const deleteProductChannelListing = async (id: number): Promise<void> => {
  await api.delete(`/productchannellistings/${id}`);
};

// Channel Stock işlemleri
export const updateChannelStock = async (listingId: number, stock: {
  quantity?: number;
  reservedQuantity?: number;
}): Promise<{ quantity: number; reservedQuantity: number; availableQuantity: number; lastUpdated: string }> => {
  const { data } = await api.patch(`/productchannellistings/${listingId}/stock`, stock);
  return data;
};

// Channel Stock Rules
export const fetchChannelStockRules = async (channelId?: number): Promise<ChannelStockRuleDto[]> => {
  const url = channelId ? `/channelstockrules?channelId=${channelId}` : '/channelstockrules';
  const { data } = await api.get<ChannelStockRuleDto[]>(url);
  return data;
};

export const createChannelStockRule = async (rule: {
  channelId: number;
  ruleType: number;
  value: number;
  priority: number;
}): Promise<ChannelStockRuleDto> => {
  const { data } = await api.post<ChannelStockRuleDto>('/channelstockrules', rule);
  return data;
};

export const updateChannelStockRule = async (id: number, rule: {
  value?: number;
  priority?: number;
}): Promise<ChannelStockRuleDto> => {
  const { data } = await api.put<ChannelStockRuleDto>(`/channelstockrules/${id}`, rule);
  return data;
};

export const deleteChannelStockRule = async (id: number): Promise<void> => {
  await api.delete(`/channelstockrules/${id}`);
};

